import { FC } from "react";

import TableCurrentEmployees from "../../../components/table/employees/TableCurrentEmployees";

const CurrentEmployees: FC = () => {
    return (
        <div style={{height: 'calc(100% - 37px)'}}>
            <TableCurrentEmployees />
        </div>
    );
};

export default CurrentEmployees;